/**
 * Immunization Service
 * Patient immunization records and vaccine tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ImmunizationTypeResponseDto { 
    /**
     * Immunization type identifier
     */
    id: string;
    /**
     * Collection identifier
     */
    collectionId: string;
    /**
     * Unique slug for the immunization type
     */
    slug: string;
    /**
     * Display name of the immunization type
     */
    display: string;
    /**
     * Description of the immunization type
     */
    description?: string;
    /**
     * Status of the immunization type
     */
    status: ImmunizationTypeResponseDto.StatusEnum;
    /**
     * Metadata schema for the immunization type
     */
    metadataSchema?: any;
    /**
     * Record schema for the immunization type
     */
    recordSchema?: any;
    /**
     * Form identifier associated with the immunization type
     */
    formId?: string;
}
export namespace ImmunizationTypeResponseDto {
    export type StatusEnum = 'draft' | 'active' | 'inactive';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


